import MyTable, { TableRow } from "../../../components/MyTable";

import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "../../my-potal/documents/downloadButtonDocument";
import { CONTRACT_DOCUMENT_SIGNATURE_REQUEST } from "../../../constants/signalRequestConsts";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { InMyChargeEmployeePaymentSlipsRequestId } from "../../../store/slices/userRequests";



interface TablePaymentSlipsProps {
    requestId: InMyChargeEmployeePaymentSlipsRequestId,
    description: string;
    setDescription: (desc: string) => void;
    pageSize: number;
    setPageSize: (page: number) => void;
    page: number;
    setPage: (page: number) => void;
    setStatusValue: (val: string) => void;
    statusValue: string;
}

const TablePaymentSlips = ({
    requestId, 
    description,
    setDescription,
    pageSize,
    setPageSize,
    page,
    setPage,
}: TablePaymentSlipsProps) => {

    const {payments, totalItems} = useSelector((state: RootState) => state.userRequests)[requestId];

    const MyButton = (headRow: TableHeadRows, row: TableRow<string, any>) => {
        if (row.VerBoleta !== 1) {
            return <></>
        }
        return (
            <DownloadButtonDocument
                FirmaTop={row.FirmaTop}
                NroFs={row.NroFS}
                FirmadoFecha={row.FirmadoFecha} 
                IdDocument={row.NroBoletaNomina}
                requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                signDisabled={true}
                signButton={false}
            />
        )
    }
    
    const tableHeadRows = [
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
            allowOrderAction: true,
        },{
            label: "Periodo",
            rowKeyName: "Periodo",
            buildOrderValue: (row: string) => {
                const value = row.split(" ").slice(1, 5).join("")
                return value
            },
            allowOrderAction: true,
        },{
            label: "Número",
            rowKeyName: "NumeroDocumento",
            allowOrderAction: true,
        },{
            label: "Tipo de documento",
            rowKeyName: "TipoDocumento",
            allowOrderAction: true,
        },{
            label: "Fecha de envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },{
            label: "Fecha de firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },{
            label: "",
            rowKeyName: "viewFile",
            customValue: MyButton,
        }
    ,];

    return  (
        <>
        <MyTable
            key="tab-0"
            pageNumber={page}
            itemsPerPage={pageSize}
            totalItems={totalItems}
            totalPages={totalItems / pageSize}
            searchInputString={description}
            onChangePageNumber={setPage}
            onChangeItemsPerPage={setPageSize}
            onChangeSearchInputString={setDescription}
            hiddenSearchInput={false}
            tableHeadRows={tableHeadRows}
            tableRows={payments}
            loading={false}
            tableOptionsBar={{
                useDrawer: true,
            }}
        />
        </>
    )
}

export default TablePaymentSlips